var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnatomyBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 30,
    viewBox: "0 0 9 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FB5152",
    d: "M4.5 3.136V26.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8C2.57 8 1 6.43 1 4.5S2.57 1 4.5 1 8 2.57 8 4.5 6.43 8 4.5 8M4.5 29C2.57 29 1 27.43 1 25.5S2.57 22 4.5 22 8 23.57 8 25.5 6.43 29 4.5 29",
    stroke: "#FFF",
    fill: "#FB5152"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnatomyBack);
export default __webpack_public_path__ + "static/media/anatomy-back.d5b1745606d4cdaa648fac5c05d7d90e.svg";
export { ForwardRef as ReactComponent };